import React, { useState, useEffect } from "react";
import { Typography, Table, Collapse, Card} from "antd";
import Pageloader from "../../../../../components/loader";
import moment from "moment";
import * as orderManagementActions from "../../../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Text } = Typography;
const { Panel } = Collapse;

const ASSIGNMENT_REASON_LABELS = {
  rider_on_the_way: "Cash Limit - Rider On the Way",
  rider_should_deposit: "Cash Limit - Rider Should Deposit",
  increase_cash_limit: "Cash Limit - Increase Cash Limit",
  cashLimit: "Cash Limit",
  stackingLimit: "Stacking Limit",
  orderValueLimit: "Order Value Limit",
  stackingDistance: "Stacking Distance",
  no_available_riders: "No Available Riders",
  no_rider_location_available: "No Rider Location Available",
};

const formatAssignmentReason = (value) => {
  if (!value) {
    return "-";
  }
  return value
    .split(",")
    .map((part) => ASSIGNMENT_REASON_LABELS[part.trim()] || part.trim())
    .join(", ");
};

const numberFormatter = new Intl.NumberFormat();

const formatNumber = (value) => {
  if (value == null || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return numberFormatter.format(num);
};

const OrderAssignmentRequests = (props) => {
  const pagename = "Assignment Requests";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   postLists();
  // }, [props.pageorderid]);

  const postLists = async () => {
    try {
      console.log("in try")
      setLoading(true);
      const pageData = {
        ...props.storeIdsFilter,
        currentPage: 1,
        limit: 10,
      };
      const {data} = await props.orderManagementActions.assignmentRequestsAction(props.pageorderid, pageData);
      setPostData(data);
      // console.log("assign", data)
    } catch (e) { 
      console.log("in catch")
    } finally {
      console.log("in catch")
      setLoading(false);
    }
  };

  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.storeIdsFilter,
      currentPage: page,
      limit: limit,
    };
    try {
      setLoading(true);
      const {data} = await props.orderManagementActions.assignmentRequestsAction(props.pageorderid, pageData);
      setPostData(data);
      // console.log("assign", data)
    } catch (e) { } finally {
      setLoading(false);
    }
  };

  const postColumns = [
    {
      title: "Rocky ID",
      render: (value) => {return value?<Text>{value.display_id}</Text> : "-";},
      dataIndex: "rider",
      key: "display_id",
    },
    {
      title: "Rider name",
      render: (value) => {return value && value.fullName?<Text>{value.fullName}</Text> : "-";},
      dataIndex: "rider",
      key: "fullName",
    },
    {
      title: "Status",
      render: (value) => {return value?<Text>{value}</Text> : "-";},
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Reason",
      render: (value) => {return value?<Text>{formatAssignmentReason(value)}</Text> : "-";},
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Assigned time",
      render: (value) => {return value?moment(value).format("DD MMMM, yyyy, h:mm:ss A"): "-";},
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Force assign",
      render: (value) => {return <Text>{`${value}`}</Text>;},
      dataIndex: "force_assign",
      key: "force_assign",
    },
    // {
    //   title: "accept/ decline",
    //   render: (value) => {return value?<Text>{value}</Text> : "?";},
    //   dataIndex: "aa",
    //   key: "accept/decline",
    // },
    {
      title: "Assign by",
      render: (value) => {return value?<Text>{value}</Text> : "-";},
      dataIndex: "assigned_by",
      key: "assigned_by",
    },
    // {
    //   title: "Acceptance/ Decline/ Timeout time",
    //   render: (value) => {return value?<Text>{value}</Text> : "?";},
    //   dataIndex: "aa",
    //   key: "acceptance/decline/timeoutTime",
    // },
    {
      title: "Rider balance",
      render: (value, record) => {
        const balance =
          record.wallet_balance !== null && record.wallet_balance !== undefined
            ? record.wallet_balance
            : record.rider?.wallet_balance !== null &&
              record.rider?.wallet_balance !== undefined
            ? record.rider.wallet_balance
            : null;
        return <Text>{formatNumber(balance)}</Text>;
      },
      dataIndex: "rider",
      key: "wallet_balance",
    },
    {
      title: "Wallet Limit",
      render: (value) => <Text>{formatNumber(value)}</Text>,
      dataIndex: "wallet_limit",
      key: "wallet_limit",
    },
    {
      title: "Order Value",
      render: (value) => <Text>{formatNumber(value)}</Text>,
      dataIndex: "order_value",
      key: "order_value",
    },
    {
      title: "Expected Return Time",
      render: (value) => {return value ? <Text>{value}</Text> : "-";},
      dataIndex: "expected_return_time",
      key: "expected_return_time",
    },
    {
      title: "Alert Sent",
      render: (value) => {return value ? <Text>{value}</Text> : "-";},
      dataIndex: "alert_sent",
      key: "alert_sent",
    },
    {
      title: "Assignment Distance",
      render: (value) => {return value?<Text>{value}</Text> : "-";},
      dataIndex: "distance_from_mart",
      key: "distance_from_mart",
    },
    // {
    //   title: "Current stacked order amount",
    //   render: (value) => {return value?<Text>{value}</Text> : "?";},
    //   dataIndex: "aa",
    //   key: "current_stacked_order_amount",
    // },
    // {
    //   title: "Current order in stack",
    //   render: (value) => {return value?<Text>{value}</Text> : "?";},
    //   dataIndex: "aa",
    //   key: "current_order_in_stack",
    // },
  ];

  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?postLists:()=>{}}>
        <Panel header={pagename}>
        {/* <Panel header={pagename} onClick={() => {console.log("postData onclick: ",postData); if(postData==null) {postLists(); console.log("in click if"); return false;} return false}}> */}
          {loading ? (<Pageloader />) : (
            <Table
              dataSource={postData && postData.data}
              columns={postColumns}
              pagination={{
                total: postData && postData.pagination.totalCount,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                pageSize:  postData && postData.pagination.limit,
                defaultCurrent:  postData && postData.pagination.currentPage,
                pageSizeOptions: ["10", "20", "30", "40", "50"],
                showSizeChanger: true,
                onChange: (currentPage, pageSize) => {
                  paginationChange(currentPage, pageSize);
                },
              }}
              />
          )}
        </Panel>
      </Collapse>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    taskDetailData: state.OrderManagementReducer.taskDetailData,
    emailUser: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderAssignmentRequests);

